// Validation Util Functions
//////////////////////////////
const isPOBox = (address) => {
  var poBox =
    /(?:P(?:ost(?:al)?)?[\.\-\s]*(?:(?:O(?:ffice)?[\.\-\s]*)?B(?:ox|in|\b|\d)|o(?:ffice|\b)(?:[-\s]*\d)|code)|box[-\s\b]*\d)/i;
  if (poBox.test(address)) {
    return true;
  }
  return false;
};

const hasNumberAndLetters = (input) => {
  return /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(input);
};

const hasOnlyNumbers = (input) => {
  return /^\d+$/.test(input);
};

const findLocale = () => {
  return localStorage.getItem('locale');
};

// Address Validation Function
//////////////////////////////
export const validateForm = (form) => {
  // Suppress the default bubbles
  form.addEventListener(
    'invalid',
    (event) => {
      event.preventDefault();
    },
    true
  );
  // Support Safari, iOS Safari, and the Android browser—each of which do not prevent
  // form submissions by default
  form.addEventListener('submit', (event) => {
    if (!this.checkValidity()) {
      event.preventDefault();
    }
  });
  const submitButton = form.querySelector('button:not([type=button]), input[type=submit]');
  submitButton.addEventListener('click', () => {
    const invalidFields = form.querySelectorAll(':invalid');
    const errorMessages = form.querySelectorAll('.input-error-text');
    // Select address fields for special PO Box validation
    const address1 = form.querySelector('[name="address[address1]"]');
    const address2 = form.querySelector('[name="address[address2]"]');
    const addressFields = [];
    // Add address fields to array of address fields
    if (address1) addressFields.push(address1);
    if (address2) addressFields.push(address2);

    // Remove current error messages
    for (let i = 0; i < errorMessages.length; i++) {
      if (errorMessages[i]) {
        errorMessages[i].innerHtml = '';
        errorMessages[i].classList.add('hidden');
      }
    }
    // Exclude UK
    if (findLocale() !== 'en-GB') {
      // Check if Address 1 has numbers and letters
      if (address1) {
        // if (hasNumberAndLetters(address1.value) !== true) {
        if (!hasNumberAndLetters(address1.value)) {
          handleErrorMessages(address1, 'Please enter a valid address with street name and number.')
        }
      }
    }

    // Check if GB address 1 has only numbers
    if (findLocale() === 'en-GB') {
      // Check if Address 1 has numbers and letters
      if (address1) {
        // if (hasOnlyNumbers(address1.value) === true) {
        if (hasOnlyNumbers(address1.value)) {
          handleErrorMessages(address1, 'Please enter a valid street address');
        }
      }
    }

    if (addressFields.length >= 1) {
      for (let i = 0; i < addressFields.length; i++) {
        if (addressFields[i].value !== null) {
          if (isPOBox(addressFields[i].value)) {
            handleErrorMessages(addressFields[i], 'Please do not use PO Box as an address.');
          }
        }
      }
    }

    for (let i = 0; i < invalidFields.length; i++) {
      if (invalidFields[i]) {
        displayError(invalidFields[i], invalidFields[i].validationMessage);
        // Hide errors when input is clicked
        invalidFields[i].addEventListener('focus', () => {
          hideError(invalidFields[i]);
        });
      }
    }
  });
};

const handleErrorMessages = (element, message) => {
  element && element.setAttribute('invalid', 'true');
  element && element.setCustomValidity('Invalid field.');
  displayError(element, message);
  element && element.addEventListener('focus', () => {
    element && element.setAttribute('invalid', 'false');
    element && element.setCustomValidity('');
    hideError(element);
  });
};

const displayError = (formElement, errorMessage) => {
  // Make invalid input border red
  formElement && formElement.classList.add('input-error');
  // Check if input formElement parent has a small tag
  Object.keys(formElement.parentNode.children).forEach((key) => {
    // Check for element with class "input-error-text hidden"
    if (
      formElement &&
      formElement.parentNode &&
      formElement.parentNode.children &&
      formElement.parentNode.children[key] &&
      formElement.parentNode.children[key].classList.value == 'input-error-text hidden'
    ) {
      // Add error text to element and show it
      formElement.parentNode.children[key].innerText = errorMessage;
      formElement.parentNode.children[key].classList.remove('hidden');
    }
  });
};
const hideError = (formElement) => {
  formElement.classList.remove('input-error');
  // Check if input field parent has a small tag
  Object.keys(formElement.parentNode.children).forEach((key) => {
    // Check for element with class "input-error-text hidden"
    if (
      formElement &&
      formElement.parentNode &&
      formElement.parentNode.children &&
      formElement.parentNode.children[key] &&
      formElement.parentNode.children[key].classList.value == 'input-error-text'
    ) {
      // Remove error text
      formElement.parentNode.children[key].innerText = '';
      formElement.parentNode.children[key].classList.add('hidden');
    }
  });
};

// Validate "New Address Form" located at customer-new-address.liquid.
//////////////////////////////
const newAddressForm = document.getElementById('address_form_new');
validateForm(newAddressForm);
// Validate "Edit Address Forms" located at customer-address.liquid.
//////////////////////////////
const editAddressForms = document.querySelectorAll('#editAddressForm form');
for (let i = 0; i < editAddressForms.length; i++) {
  validateForm(editAddressForms[i]);
}
